export default __webpack_public_path__ + "static/media/SwoopLogo.8e92a3f0.svg";